export default {
  pt: {
    'shipments.colheitaSection.titulo': 'Colheita',
    'shipments.colheitaSection.registros': 'Programações',
    'shipments.colheitaSection.cargasProgramadas': 'Cargas programadas',
    'shipments.colheitaSection.dataInicio': 'Data início',
    'shipments.colheitaSection.dataFim': 'Data fim',
    'shipments.colheitaSection.cargasSolicitadas_one': 'carga solicitada',
    'shipments.colheitaSection.cargasSolicitadas_other': 'cargas solicitadas',
    'shipments.colheitaSection.cargasAtendidas_one': 'carga atendida',
    'shipments.colheitaSection.cargasAtendidas_other': 'cargas atendidas',
    'shipments.colheitaSection.adicionar': 'Adicionar colheita',
    'shipments.colheitaSection.editar': 'Editar colheita',
    'shipments.colheitaSection.escala': 'Escala da colheita',
    'shipments.colheitaSection.excluir': 'Excluir colheita',
    'shipments.colheitaSection.excluida': 'Colheita excluída.',
    'shipments.colheitaSection.excluirTitulo': 'Excluir esta programação de colheita?',
    'shipments.colheitaSection.excluirMensagem': 'A programação {{nome}} sai da frente, com as máquinas e operadores dela. A exclusão não pode ser desfeita.',
    'shipments.colheitaSection.vazio': 'Nenhuma colheita programada nesta frente.',
    'shipments.colheitaSection.vazioFiltro': 'Nenhuma colheita no recorte atual.',
    'shipments.colheitaSection.filtroData': 'Data',
    'shipments.colheitaSection.filtroMaquina': 'Máquina',
    'shipments.colheitaSection.filtroOperador': 'Operador',
    'shipments.colheitaSection.semMaquina': 'Sem máquina',
    'shipments.colheitaSection.semOperador': 'Sem operador',
    'shipments.colheitaSection.lancar': 'Lançar cargas atendidas',
    'shipments.colheitaSection.lancarFuturo': 'O lançamento abre no dia da colheita.',
    'shipments.colheitaSection.status.pendente': 'Pendente',
    'shipments.colheitaSection.status.em_andamento': 'Em andamento',
    'shipments.colheitaSection.status.lancado': 'Lançado',
  },
  en: {
    'shipments.colheitaSection.titulo': 'Harvest',
    'shipments.colheitaSection.registros': 'Schedules',
    'shipments.colheitaSection.cargasProgramadas': 'Planned loads',
    'shipments.colheitaSection.dataInicio': 'Start date',
    'shipments.colheitaSection.dataFim': 'End date',
    'shipments.colheitaSection.cargasSolicitadas_one': 'load requested',
    'shipments.colheitaSection.cargasSolicitadas_other': 'loads requested',
    'shipments.colheitaSection.cargasAtendidas_one': 'load attended',
    'shipments.colheitaSection.cargasAtendidas_other': 'loads attended',
    'shipments.colheitaSection.adicionar': 'Add harvest',
    'shipments.colheitaSection.editar': 'Edit harvest',
    'shipments.colheitaSection.escala': 'Harvest schedule',
    'shipments.colheitaSection.excluir': 'Delete harvest',
    'shipments.colheitaSection.excluida': 'Harvest deleted.',
    'shipments.colheitaSection.excluirTitulo': 'Delete this harvest schedule?',
    'shipments.colheitaSection.excluirMensagem': 'Schedule {{nome}} leaves the work front, along with its machines and operators. Deletion cannot be undone.',
    'shipments.colheitaSection.vazio': 'No harvest scheduled for this work front.',
    'shipments.colheitaSection.vazioFiltro': 'No harvest in the current selection.',
    'shipments.colheitaSection.filtroData': 'Date',
    'shipments.colheitaSection.filtroMaquina': 'Machine',
    'shipments.colheitaSection.filtroOperador': 'Operator',
    'shipments.colheitaSection.semMaquina': 'No machine',
    'shipments.colheitaSection.semOperador': 'No operator',
    'shipments.colheitaSection.lancar': 'Record attended loads',
    'shipments.colheitaSection.lancarFuturo': 'Recording opens on the harvest day.',
    'shipments.colheitaSection.status.pendente': 'Pending',
    'shipments.colheitaSection.status.em_andamento': 'In progress',
    'shipments.colheitaSection.status.lancado': 'Recorded',
  },
  es: {
    'shipments.colheitaSection.titulo': 'Cosecha',
    'shipments.colheitaSection.registros': 'Programaciones',
    'shipments.colheitaSection.cargasProgramadas': 'Cargas previstas',
    'shipments.colheitaSection.dataInicio': 'Fecha de inicio',
    'shipments.colheitaSection.dataFim': 'Fecha de fin',
    'shipments.colheitaSection.cargasSolicitadas_one': 'carga solicitada',
    'shipments.colheitaSection.cargasSolicitadas_other': 'cargas solicitadas',
    'shipments.colheitaSection.cargasAtendidas_one': 'carga atendida',
    'shipments.colheitaSection.cargasAtendidas_other': 'cargas atendidas',
    'shipments.colheitaSection.adicionar': 'Agregar cosecha',
    'shipments.colheitaSection.editar': 'Editar cosecha',
    'shipments.colheitaSection.escala': 'Programación de cosecha',
    'shipments.colheitaSection.excluir': 'Eliminar cosecha',
    'shipments.colheitaSection.excluida': 'Cosecha eliminada.',
    'shipments.colheitaSection.excluirTitulo': '¿Eliminar esta programación de cosecha?',
    'shipments.colheitaSection.excluirMensagem': 'La programación {{nome}} sale del frente, con sus máquinas y operadores. La eliminación no se puede deshacer.',
    'shipments.colheitaSection.vazio': 'No hay cosecha programada en este frente.',
    'shipments.colheitaSection.vazioFiltro': 'No hay cosecha en el recorte actual.',
    'shipments.colheitaSection.filtroData': 'Fecha',
    'shipments.colheitaSection.filtroMaquina': 'Máquina',
    'shipments.colheitaSection.filtroOperador': 'Operador',
    'shipments.colheitaSection.semMaquina': 'Sin máquina',
    'shipments.colheitaSection.semOperador': 'Sin operador',
    'shipments.colheitaSection.lancar': 'Registrar cargas atendidas',
    'shipments.colheitaSection.lancarFuturo': 'El registro se abre el día de la cosecha.',
    'shipments.colheitaSection.status.pendente': 'Pendiente',
    'shipments.colheitaSection.status.em_andamento': 'En curso',
    'shipments.colheitaSection.status.lancado': 'Registrado',
  },
}
